import styled from 'styled-components'

export const FADE_OVERLAY_HEIGHT = '40px'

export const Wrapper = styled.div<{ $maxHeight: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: ${({ $maxHeight }) => $maxHeight};
  overflow: hidden;
`

export const FadeOverlay = styled.div<{
  $visible: boolean
  $fadeColor: string
}>`
  pointer-events: none;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: ${FADE_OVERLAY_HEIGHT};
  background: linear-gradient(
    to bottom,
    transparent,
    ${({ $fadeColor }) => $fadeColor}
  );
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.15s ease-out;
`
